import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DjPsycho} from "../DjPsycho";
import {DjPsychoGameMode} from "../server/DjPsychoGameMode";
import {TimelineLite} from "gsap";
import {DjPsychoSound} from "../sound/DjPsychoSound";

export class DjPsychoFSIntroRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return ((DjPsycho.model.gameData.mode === DjPsychoGameMode.NORMAL || DjPsycho.model.gameData.mode === DjPsychoGameMode.NORMAL_AVALANCHE) && DjPsycho.model.gameData.nextMode === DjPsychoGameMode.FREESPIN);
    }

    public start(controller: ISimplePresentationRunnerController): void {
        controller.setSkipCallback();

        const tl: TimelineLite = new TimelineLite(),
            mode: string = DjPsycho.model.gameData.mode,
            isUpgrade: boolean = (mode.indexOf(DjPsychoGameMode.NORMAL) === -1 && DjPsycho.model.gameData.nextMode === DjPsychoGameMode.FREESPIN_SUPER),
            activeColorsForFS: boolean[] = DjPsycho.model.gameData.activeColorsForFS;

        if (!(mode === DjPsychoGameMode.NORMAL && DjPsycho.model.gameData.wasFeatureBuy)) {
            tl.to(this, {
                duration: 0.1
            });

            // #167
            tl.add(() => {
                DjPsycho.soundPlayer.playSound(DjPsychoSound.FS_METER_FS_WIN);
            });

            activeColorsForFS.forEach((val: boolean, ctr: number) => {
                if (val || isUpgrade) {
                    tl.add(DjPsycho.miniCollectors.activateCollectorIndicatorSpine(ctr, isUpgrade), 0);
                }
            });
            tl.addLabel("indicatorsAnimated");
            activeColorsForFS.forEach((val: boolean, ctr: number) => {
                if (val || isUpgrade) {
                    tl.add(DjPsycho.miniCollectors.activateCollectorTextSpine(ctr, isUpgrade), "indicatorsAnimated");
                }
            });
        }
        tl.add(() => {
            if (isUpgrade) {
                DjPsycho.keypadPlugin.setZeroBetSpinCounter(DjPsycho.model.fsLeftCount + 2);
            }

            DjPsycho.introView.showIntro(() => this.fsIntroClosedCallback(controller));
        });
    }

    private fsIntroClosedCallback(controller: ISimplePresentationRunnerController): void {
        controller.finish();
    }
}